var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPayment24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_payment24x24",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M19.274,3.864a.2.2,0,0,0,.081-.383L11.69.081A.926.926,0,0,0,10.465.55L7.781,6.57A.926.926,0,0,0,8.25,7.794L9.8,8.463A.294.294,0,0,0,10.21,8.2V5.64a1.775,1.775,0,0,1,1.775-1.775h7.289Z",
    transform: "translate(-7.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M127.9,153.136H117.669a1.033,1.033,0,0,0-1.033,1.033v7.224a1.033,1.033,0,0,0,1.033,1.033h1.373a3.75,3.75,0,0,1-.051-.621,3.9,3.9,0,0,1,.064-.692h-1.107v-3.46h9.669v3.455h-1.11a3.9,3.9,0,0,1,.064.692,3.749,3.749,0,0,1-.051.621h1.373a1.033,1.033,0,0,0,1.033-1.033v-7.22A1.033,1.033,0,0,0,127.9,153.136Zm-.277,2.4H117.95v-1.083h9.669Z",
    transform: "translate(-112.926 -148.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M222.888,331.436a2.652,2.652,0,1,0,2.652,2.652A2.652,2.652,0,0,0,222.888,331.436Zm.763,3.7a.839.839,0,0,1-.444.284.123.123,0,0,0-.108.142v.236a.095.095,0,0,1-.1.108q-.127.005-.253,0c-.075,0-.108-.043-.108-.114v-.172c0-.125-.007-.131-.129-.152a1.589,1.589,0,0,1-.449-.129c-.112-.054-.125-.081-.089-.2.024-.089.047-.177.075-.26.03-.1.058-.112.152-.064a1.448,1.448,0,0,0,.5.148.606.606,0,0,0,.327-.043.253.253,0,0,0,.06-.444.685.685,0,0,0-.185-.108,3.841,3.841,0,0,1-.509-.23.717.717,0,0,1-.408-.692.76.76,0,0,1,.557-.705c.135-.051.138-.047.138-.189v-.146c0-.108.02-.125.129-.129h.1c.23,0,.23,0,.23.23,0,.162,0,.162.162.185a1.469,1.469,0,0,1,.355.1.1.1,0,0,1,.067.138c-.027.1-.054.2-.089.294s-.06.1-.148.064a1.114,1.114,0,0,0-.56-.112.447.447,0,0,0-.148.03.213.213,0,0,0-.054.378,1.079,1.079,0,0,0,.243.138,3.763,3.763,0,0,1,.444.2.8.8,0,0,1,.248,1.2Z",
    transform: "translate(-213.042 -320.741)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPayment24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_payment24x24.06b833944dd192cadb59a5c03664bd76.svg";